import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import Raven from 'raven-js';

import Layout from 'src/app/components/Layout/Layout';
import background from 'src/assets/images/background-login.jpg';
import ResetNewPasswordPresentation from 'src/app/components/ResetNewPasswordPresentation';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';
import { feedbackMessageShow } from 'src/app/redux/actions/feedbackMessage';
import alerts from 'src/app/alerts.json';
import ResetNewPasswordFormContainer from 'src/app/containers/Reset/ResetNewPasswordFormContainer';


const ResetNewPasswordContainer = ({ passwordSent, dispatch, location }) => {
  const userId = getWindowSearchParam('userId');
  const token = getWindowSearchParam('token');

  if (!(userId && token)) {
    dispatch(feedbackMessageShow(alerts.newPasswordWrongQueryParams));
    Raven.captureException(new Error('No userId and token in query params in new password section'));

    return <Redirect to={ { pathname: '/', search: location.search } }/>;
  }
  if (passwordSent) {
    return <Redirect to={ { pathname: '/', search: location.search } }/>;
  }

  return (
    <Layout>
      <LayoutLeftColumn>
        <ResetNewPasswordFormContainer />
      </LayoutLeftColumn>
      <LayoutRightColumn background={ background }>
        <ResetNewPasswordPresentation />
      </LayoutRightColumn>
    </Layout>
  );
};

ResetNewPasswordContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  passwordSent: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  ...state.resetNewPasswordSendReducer
});

export default connect(mapStateToProps)(withRouter(ResetNewPasswordContainer));
